import $ from 'jquery';
import { MDCSwitch } from '@material/switch';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';

Component('tr-switch-field', {
  mixins: [eventListenerMixin],

  properties: {
    checked: {
      type: Boolean,
      default: false,
      observer() {
        this.checkedChanged();
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      observer() {
        this.disabledChanged();
      },
    },
  },

  connected() {
    this.nativeField = this.querySelector('input[type="checkbox"]');
    if (!this.nativeField.classList.contains('mdc-switch__native-control')) {
      this.nativeField.classList.add('mdc-switch__native-control');
    }

    this.mdcSwitch = new MDCSwitch(this.querySelector('.mdc-switch'));
    if (this.checked) this.mdcSwitch.checked = this.checked;

    this.listenTo(this.nativeField, {
      change: this.handleCheckboxChanged.bind(this),
    });

    $(this).on('ajax:send', () => { this.disabled = true; });
    $(this).on('ajax:complete', () => { this.disabled = false; });
  },

  disconnected() {
    this.stopListening();
    if (this.mdcSwitch) this.mdcSwitch.destroy();
  },

  handleCheckboxChanged(event) {
    const { checked, value } = event.target;

    this.checked = checked;
    this.namespacedTrigger('change', {
      detail: { checked, value },
      bubbles: true,
    });
  },

  checkedChanged() {
    this.mdcSwitch.checked = this.checked;
  },

  disabledChanged() {
    this.mdcSwitch.disabled = this.disabled;
  },
});
